//region 1. Platform Libraries
import bodyParser from 'body-parser';
import express from 'express';
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkStreamIndex from '../middleware/checkStreamIndex';
//endregion

const context = {
        router: express.Router({ mergeParams: true }),
        cameras: null,
        logger: null,
};

context.router.use('/', bodyParser.json());
context.router.use('/', checkObjectID);
context.router.use('/', checkStreamIndex);

context.router.post('/', (req, res) => {
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `POST ${req.originalUrl}` });
        log('debug', JSON.stringify(req.body, null, 2));
        [
                'type',
                'time',
        ].forEach((property) => {
                if ({}.hasOwnProperty.call(req.body, property)) {
                        return;
                }
                const message = `Event Contains No ${property}`;
                log('error', message);
                res.status(400).send(message);
        });
        const diff = {};
        diff[`streams.${req.params.index}.events`] = {
                type: req.body.type,
                time: parseInt(req.body.time, 10),
                status: 'Pending',
                videos: [],
        };
        const _id = new MongoClient.ObjectID(req.params.id);
        context.cameras.updateOne({ _id }, { $push: diff }, (err, result) => {
                if (err) {
                        log('error', err.message);
                        res.status(500).send(err.message);
                        return;
                }
                if (!result.matchedCount) {
                        const message = 'Camera Not Found';
                        log('error', message);
                        res.status(500).send(message);
                        return;
                }
                log('info', '200 OK');
                res.sendStatus(200);
        });
});

context.router.put('/', (req, res) => {
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `PUT ${req.originalUrl}` });
        log('debug', JSON.stringify(req.query));
        log('debug', JSON.stringify(req.body));
        if (!{}.hasOwnProperty.call(req.body, 'videoInfo')) {
                const message = 'Event Contains No Video Info';
                log('error', message);
                res.status(400).send(message);
                return;
        }
        const query = { _id: new MongoClient.ObjectID(req.params.id) };
        query[`streams.${req.params.index}.events.time`] = parseInt(req.query.time, 10);
        log('debug', JSON.stringify(query, null, 2));
        const diff = {};
        diff[`streams.${req.params.index}.events.$.videos`] = [req.body.videoInfo];
        log('debug', JSON.stringify(diff, null, 2));
        context.cameras.updateOne(query, { $set: diff }, (err, result) => {
                if (err) {
                        log('error', err.message);
                        res.status(500).send(err.message);
                        return;
                }
                if (!result.matchedCount) {
                        const message = 'Camera Not Found';
                        log('error', message);
                        res.status(500).send(message);
                        return;
                }
                log('info', '200 OK');
                res.sendStatus(200);
        });
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /c/:/s/:/events
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountEvents(options) {
        context.logger = options.logger;
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountEvents' });
        log('debug', 'Mounting router for /c/:/s/:/events....');
        options.app.use('/cameras/:id/streams/:index/events', context.router);
        context.cameras = options.database.collection('cameras');
        log('info', 'Router for /c/:/s/:/events Mounted');
}
